import { Injectable } from '@angular/core';
import { CurrencyService } from '../currency.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CotizadorService } from './cotizador.service';
import { environment } from 'environments/environment';
import {Http, Response, Headers} from '@angular/http';

@Injectable()
export class UpgradeService {
  public modelPoliza;
  public modelCotizacion;
  public model;
  private idTipo;
  private id;

  //NOTIFICACION
  public tituloSolicitar;
  public mensajeSolicitar;
  public rutaSolicitar;

  constructor(private http:Http, public _currencyService:CurrencyService,private route: ActivatedRoute,private router: Router,private cs:CotizadorService) { }

  ngOnInit() {}

  upgradeDetail(params){
    try{
      let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
      let url= `${environment.serviceUrl}upgrade`;
      return this.http.post(url,params, {headers: headers}).toPromise().then(response => {
        return response.json() as String;
      }).catch(this.handleError)
    }
    catch(error){}
  }
  // consulta los upgrade del api de heiber IA
  getUpgradesApi(params){
    try{
      let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
      let url= `${environment.apiUpgrade}/getUpgrades`;
      let data = [];
      return this.http.post(url,params, {headers: headers}).toPromise().then(response => {
        if(response.status==200){
          data = [...response.json().data];
          console.log(data);
        }
      return data;
      }).catch(this.handleError)
    }
    catch(error){}
  }

  getUpgrades(params){
    try{
      let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
      let url= `${environment.serviceUrl}upgrades`;
      return this.http.post(url,params, {headers: headers}).toPromise().then(response => {
        return response.json() as String;
      }).catch(this.handleError)
    }
    catch(error){}
  }

  /**
    * Handles error thrown during HTTP call
    * @param error:any
    * @returns {Promise<never>}
    */
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); //
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/general/upgrade.service.ts